<script>
  import Layout from "../../Layout/Layout.svelte";
  import config from "../../stores/config";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";
  import AdminRow from "./AdminRow.svelte";
  import { Wave } from "svelte-loading-spinners";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import * as ls from "local-storage";
  import Select from "svelte-select";

  let admins = null;
  let queryURL = "";
  let isSuperAdmin = false;
  let department;

  $: {
    if (admins && $config.currentUser) {
      admins = admins.filter((u) => u.username != $config.currentUser.username);
      if ($config.currentUser.role == "super-admin") isSuperAdmin = true;
    }
  }

  /* Query Parameters, just CHANGE them and the query will be regenerated as well, NO need to change everything */
  let page = 1;
  let searchKey = "";

  const fetchAdmins = () => {
    admins = null;

    queryURL = `${$config.backendURL}/users/page/${page}?role=admin`;
    queryURL += `&searchKey=${searchKey || ""}`;

    axios
      .get(queryURL, { headers: { authorization: ls.get("jwt") } })
      .then((res) => {
        admins = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchAdmins();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchAdmins();
  };

  const handleRefresh = () => {
    page = 1;
    searchKey = null;
    fetchAdmins();
  };

  /* New Admin data */
  let newAdmin = {
    fullname: "",
    username: "",
    password: "",
    confirmPassword: "",
    email: "",
    tel: "",
  };

  let uploading = false;

  const handleAddAdmin = () => {
    if (newAdmin.password != newAdmin.confirmPassword) {
      alert("New password & Confirm Password Don't match");
      return;
    } else if (!department.value) {
      alert("Please select a department");
      return;
    }

    uploading = true;

    axios
      .post(
        `${$config.backendURL}/users/add-admin`,
        {
          ...newAdmin,
          username: newAdmin.username.trim(),
          password: newAdmin.password.trim(),
          department: department.value,
        },
        { headers: { authorization: ls.get("jwt") } }
      )
      .then((res) => {
        alert("☑ Done Successfully");
        console.log(res);
        uploading = false;
        fetchAdmins();
      })
      .catch((err) => {
        console.log(err);
        uploading = false;
        if ($config?.currentUser?.role != "super-admin")
          alert("Only the single super admin can add a new admin");
        else alert("Makes sure the username is not already taken");
      });
  };

  onMount(() => {
    fetchAdmins();
  });
</script>

<svelte:head>
  <title>Admins — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  {#if $config.currentUser}
    {#if $config.currentUser.department == "Management"}
      <MenuHeading
        title="Administrators"
        description="This menu will allow view, add or delete system administrators."
      />

      <!-- Search Bar -->
      <div class="flex justify-between">
        <div class="flex justify-center">
          <input
            bind:value={searchKey}
            on:input={fetchAdmins}
            class="shadow-sm"
            type="text"
            placeholder="Search "
          />
          <button class="ml-2 btn btn-primary" on:click={fetchAdmins}>
            <i class="fas fa-search" />
          </button>
        </div>
        <button class="btn btn-green" on:click={handleRefresh}>
          Reset Search Criteria
          <i class="fas fa-times-circle ml-3" />
        </button>
      </div>

      <!-- Admins Bar -->
      <div
        class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
      >
        <div class="th  border-b border-gray-100 font-semibold text-gray-600">
          <div style="min-width: 10rem; max-width: 10rem;">Actions</div>
          <div style="min-width: 10rem; max-width: 10rem;">Date</div>
          <div style="min-width: 20rem; max-width: 20rem;">Full Name</div>
          <div style="min-width: 15rem; max-width: 15rem;">Username</div>
          <div style="min-width: 10rem; max-width: 10rem;">Telephone</div>
          <div style="min-width: 15rem; max-width: 15rem;">Email</div>
          <div style="min-width: 15rem; max-width: 15rem;">Department</div>
        </div>

        {#if admins}
          {#each admins as admin (admin._id)}
            <AdminRow {...admin} on:delete={fetchAdmins} />
          {:else}
            <div class="h-52 w-full flex items-center justify-center">
              Nothing to show...
            </div>
          {/each}
        {:else}
          <div class="h-52 w-full flex items-center justify-center">
            <Wave size="50" color="rgb(244,162,97)" unit="px" />
          </div>
        {/if}

        <div class="tf">
          <button
            class="text-base btn btn-gray-outline"
            on:click={handlePrevPage}
          >
            <i class="fas fa-arrow-alt-circle-left mr-3" />
            Prev Page
          </button>
          <div class="mx-4">Page {page}</div>
          <button
            class="text-base btn btn-gray-outline"
            on:click={handleNextPage}
          >
            Next Page
            <i class="fas fa-arrow-alt-circle-right ml-3" />
          </button>
        </div>
      </div>

      {#if isSuperAdmin}
        <!-- Add A New Admin -->
        <h1 class="mt-16 mb-8 text-gray-500 text-xl">ADD AN ADMINISTRATOR:</h1>

        <!-- Add A New Admin -->
        <form
          on:submit|preventDefault={handleAddAdmin}
          class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
        >
          <div class="grid grid-cols-2 gap-8">
            <div class="grid grid-cols-3 gap-2 items-center">
              <div>Department:</div>
              <div class="col-span-2 shadow-sm placeholder-gray-300">
                <Select
                  items={$config.departments}
                  on:select={(e) => (department = e.detail)}
                />
              </div>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-8">
            <div class="grid grid-cols-3 gap-2 items-center">
              <div>Full Name:</div>
              <input
                class="col-span-2 shadow-sm placeholder-gray-300"
                type="text"
                bind:value={newAdmin.fullname}
                placeholder="Full Name"
                required
              />
            </div>
            <div class="grid grid-cols-3 gap-2 items-center">
              <div>User Name:</div>
              <input
                class="col-span-2 shadow-sm placeholder-gray-300"
                type="text"
                bind:value={newAdmin.username}
                placeholder="User Name"
                required
              />
            </div>
          </div>

          <div class="grid grid-cols-2 gap-8">
            <div class="grid grid-cols-3 gap-2 items-center">
              <div>Email:</div>
              <input
                class="col-span-2 shadow-sm placeholder-gray-300"
                type="text"
                bind:value={newAdmin.email}
                placeholder="Email"
                required
              />
            </div>
            <div class="grid grid-cols-3 gap-2 items-center">
              <div>Telephone:</div>
              <input
                class="col-span-2 shadow-sm placeholder-gray-300"
                type="text"
                bind:value={newAdmin.tel}
                placeholder="Telephone"
                required
              />
            </div>
          </div>

          <div class="grid grid-cols-2 gap-8">
            <div class="grid grid-cols-3 gap-2 items-center">
              <div>Password:</div>
              <input
                class="col-span-2 shadow-sm placeholder-gray-300"
                type="password"
                bind:value={newAdmin.password}
                placeholder="Password"
                required
              />
            </div>
            <div class="grid grid-cols-3 gap-2 items-center">
              <div>Confirm Password:</div>
              <input
                class="col-span-2 shadow-sm placeholder-gray-300"
                type="password"
                bind:value={newAdmin.confirmPassword}
                placeholder="Confirm Password"
                required
              />
            </div>
          </div>

          {#if uploading}
            <div class="grid grid-cols-1 gap-8">
              <div
                class="flex items-center justify-center btn btn-primary-outline"
              >
                <Wave size="25" color="rgb(244,162,97)" unit="px" />
                <span class="ml-4"> Saving, Please Wait </span>
              </div>
            </div>
          {:else}
            <div class="grid grid-cols-1 gap-8">
              <button
                class="btn btn-primary-outline"
                type="clear"
                on:click={() => {
                  newAdmin = {
                    fullname: "",
                    username: "",
                    password: "",
                    confirmPassword: "",
                    email: "",
                    tel: "",
                  };
                  department = null;
                }}
              >
                <i class="fas fa-times-circle mr-3" />
                Clear Form
              </button>
            </div>
            <div class="grid grid-cols-1 gap-8 mt-2">
              <button class="btn btn-primary">
                <i class="fas fa-check-circle mr-3" />
                Add Administrator
              </button>
            </div>
          {/if}
        </form>
      {/if}
    {/if}
  {/if}
</Layout>

<style>
  .th,
  .tf {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
